<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>

      <!--img id="header-s" src="https://i.ibb.co/1J2YTy2/Loyalty-hub-header-s.png" /-->

      <div class="title-page-l header-banner" style="min-width:240px;">
        <img
          class="icon-title"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
        <p>คะเเนนสะสม</p>
        <h1>{{ info.point  | numFormat('0,000,000') }}</h1>
        <a @click="goto('OrderHistory')" type="submit" class="fixios" style="background-color: transparent; color: white; z-index: 99; top: 5px; position: absolute; right: 80px;"><i  class="material-icons" style="font-size: 2rem; color: white; margin: 2px; vertical-align: middle;">history</i></a><a @click="goto('Cart')" type="submit" class="fixios" style="background-color: transparent; color: white; z-index: 99;position:absolute; top:5px;right:15px;"><i  class="material-icons" style="font-size: 2rem; color: white; margin: 2px; vertical-align: middle;">shopping_cart</i> {{ countCart }} </a>
      </div>
      <div>

        <div class="row">
          <div class="col">
            <div
              class="input-group flex-nowrap input-group-sm mb-3"
              style="position: static; margin-top: 80px; padding-left: 10px;
    padding-right: 10px;">
              <input
                type="text"
                v-model="search"
                class="form-control"
                placeholder="ค้นหา"
                aria-label="ค้นหา"
                aria-describedby="searchBtn"
                style="border: 1px solid"
              />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary light-color" type="button" id="searchBtn">
                  <i
                    class="material-icons font-color"
                    style="
                      font-size: 2rem;
                      margin: 2px;
                      vertical-align: middle;
                    "
                  >
                    search
                  </i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <a
              @click="goto('Product02', product._id)"
              class="row bg-white"
              v-for="(product) in products"
              :key="product._id"
            >
              <div>
                <img
                  class="img-product"
                  :src="'https://api.loyaltyhub.me/public/' + product.image"
                  v-if="product.image != ''"
                />

                <span class="name-product">{{ product.name }}</span>
                <span class="name-category" v-if="product.category !== undefined">{{
                  product.category
                }}</span>
            <br>
                <span class="name-price">{{ product.price  | numFormat('0,000,000.00') }} บาท</span>

              </div>

            </a>
          </div>
        </div>

        <div class="lastrow"></div>
      </div>
    </body>
  </html>
</template>
<script>
import Navbar from "./navbar";
export default {
  name: "",
  components: {
    navbar: Navbar,
  },
  data() {
    return {
      search: "",
      //info: this.$store.state.profile,
      //products: [],
    };
  },
  beforeMount() {
    this.$store.dispatch("listProducts", {
      custId: localStorage.getItem("custId"),
    });
  },

  computed: {
    countCart() {
      return this.$store.state.cart.filter(item=>{ return item.custId == localStorage.getItem("custId") && item.custId !== undefined }).length;
    },
    info() {
      return this.$store.state.profile;
    },
    products() {
      return this.$store.state.products.filter((item) => {
        return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },
  },
  mounted() {
     console.log(this.$store.state.products);
  },
  methods: {
    show(type) {
      console.log(type);
      this.pointType = type;
    },
    remainDate(expireDate) {
      return Math.floor((new Date(expireDate) - new Date()) / (1000 * 60 * 60 * 24));
    },
    gotoCart(page) {
      console.log(page);
      this.$router.push({
        name: page,
        /*query: {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
        },
        */
      });
    },
    goto(page, index) {
      console.log(page);
      this.$router.push({
        name: page,
        params: {
          //apiKey: localStorage.getItem("apiKey"),
          //custId: localStorage.getItem("custId"),
          productIndex: index,
        },
      });
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";

</style>
